import { render, staticRenderFns } from "./PalvelusopimusPalvelutaso.vue?vue&type=template&id=6743308e&scoped=true&"
import script from "./PalvelusopimusPalvelutaso.vue?vue&type=script&lang=js&"
export * from "./PalvelusopimusPalvelutaso.vue?vue&type=script&lang=js&"
import style0 from "./PalvelusopimusPalvelutaso.vue?vue&type=style&index=0&id=6743308e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6743308e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBadge,VBtn,VCard,VChip,VDialog,VDivider,VIcon,VList,VListItem,VListItemAvatar,VListItemContent})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6743308e')) {
      api.createRecord('6743308e', component.options)
    } else {
      api.reload('6743308e', component.options)
    }
    module.hot.accept("./PalvelusopimusPalvelutaso.vue?vue&type=template&id=6743308e&scoped=true&", function () {
      api.rerender('6743308e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PalvelusopimusPalvelutaso.vue"
export default component.exports